import { MonitorParameter } from "@/global/interface/monitor-object/monitor-parameter"
import { useContext, useEffect, useRef, useState } from "react";
import { ReactComponent as ShowSvg } from '../icons/show.svg'
import { ReactComponent as EditSvg } from '../icons/edit.svg'
import classNames from "classnames";
import { CommonTabbarState } from "@/global/components/common-tabbar";
import { CommonTabbarContext } from "@/App";
import { TAB_TYPE } from "@/enums/tab-type";
import { DRAW_MAIN_KEY } from "@/layout/main";
import { emitter } from "@/global/listeners";
import { Emit_Event } from "@/enums/emit-event";
import { getSensorTypeName } from "@/enums/sensor-type";
import { Sensor } from "@/global/interface/device/sensor";
import TnMessage from "@/global/components/message";

interface Iprops {
    monitorParameter: MonitorParameter // 监测参数
    activedParamId: number, // 激活的参数id
    onUpdateParam: (id: number, data: MonitorParameter) => void // 更新了监测参数
}
export default function MonitorParameterItem(props: Iprops) {
    const { monitorParameter, activedParamId } = props
    const [item, setItem] = useState<MonitorParameter>();
    const itemRef = useRef(item);
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文

    useEffect(() => {
        setItem(monitorParameter);
        return (() => {
            emitter.off(Emit_Event.MATCH_SENSOR_FINISH, onMatchSensorFinish);
            emitter.off(Emit_Event.UPDATE_MONITOR_PARAMETER, onUpdateMonitorParameterFinish);
        })
    }, [monitorParameter])

    useEffect(() => {
        itemRef.current = item
    }, [item])

    // 点击了展开收起
    const handleExpandItem = () => {
        setItem({ ...item, expanded: !item.expanded });
    }

    // 匹配传感器
    const onMatchSensor = (param: MonitorParameter) => {
        // 从图形中选择传感器
        // 打开绘图区
        commonTabbarContext.navigate(`${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`)
        // 发信号
        emitter.emit(Emit_Event.MATCH_SENSOR, param);
        // 监听匹配完成的信号
        emitter.on(Emit_Event.MATCH_SENSOR_FINISH, onMatchSensorFinish);
    }

    // 匹配了传感器参数完成
    const onMatchSensorFinish = (result) => {
        // 侧边栏显示传感器名称
        let param: MonitorParameter = result.param;
        let sensor: Sensor = result.sensor;
        if (!param.id) return;
        let pDq = itemRef.current.subParametersDq.find(item => item.id == param.id);
        if (!pDq) return;
        pDq.sensorId = sensor.id;
        pDq.sensorType = sensor.type;
        pDq.sensorCode = sensor.code;
        setItem({ ...itemRef.current, expanded: true });
        // 移除监听
        emitter.off(Emit_Event.MATCH_SENSOR_FINISH, onMatchSensorFinish);
    }

    // 打开传感器详情
    const onOpenSensorDetail = (sensorId: number, sensorType: number) => {
        commonTabbarContext.navigate(`${TAB_TYPE.DEVICE}/${sensorId}/sensor`)
    }

    // 打开监测参数详情
    const openMonitorParameterDetail = (e) => {
        e.stopPropagation();
        setItem({ ...item, expanded: true });
        commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_PARAMETER}/${item.id}`)
        // 监听更新监测参数的信号
        emitter.on(Emit_Event.UPDATE_MONITOR_PARAMETER, onUpdateMonitorParameterFinish);
    }

    // 更新了监测参数的详情
    const onUpdateMonitorParameterFinish = (result: MonitorParameter) => {
        if (result?.id != item.id) return;
        setItem({ ...itemRef.current, ...result, expanded: true });
        props.onUpdateParam(item.id, { ...itemRef.current, ...result, expanded: true })
    }

    if (!item) {
        return (<div></div>)
    }

    return (
        <div className="monitor-parameter-item">
            <div className={classNames({
                "param-title": true,
                "selected": activedParamId == item.id,
            })} onClick={handleExpandItem}>
                <div className="name">
                    <span style={{ width: '22px' }}>{item.encoding}</span>
                    <span style={{ marginLeft: '8px' }}>{item.name}</span>
                    <span style={{ marginLeft: '8px' }}>{item.code}</span>
                    <ShowSvg className={classNames({
                        "arrow-icon": true,
                        "expanded": item.expanded
                    })} />
                </div>
                <div className="detail-btn" onClick={(e) => openMonitorParameterDetail(e)}><div className="text">详情</div></div>
            </div>
            {item.expanded && (
                <div className="param-dq-list">
                    {(item.subParametersDq || []).map((param, idx) => (
                        <div key={idx} className="param">
                            <div className="param-name">{item.encoding}-{param.location}<span style={{ marginLeft: '8px' }}>{param.name}</span></div>
                            {!param.sensorId && <div className="match-btn" onClick={() => onMatchSensor(param)}><div className="text">匹配</div></div>}
                            {param.sensorId && <div className="sensor-info">
                                <div className="sensor-code" onClick={() => onOpenSensorDetail(param.sensorId, param.sensorType)}><div className="text ellipsis" title={`${getSensorTypeName(param.sensorType)}-${param.sensorCode}`}>{getSensorTypeName(param.sensorType)}-{param.sensorCode}</div></div>
                                <EditSvg className="edit-btn" onClick={() => onMatchSensor(param)} />
                            </div>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}